export const call = {
  state: {
    init: {
      description: `
            Call Forwarding - elemen sirkuit yang memungkinkan Anda mengarahkan panggilan masuk ke metode kontak yang ada.
            Anda dapat menambahkan metode kontak baru di akun Anda di`
    }
  },
  input: {
    timeout: {
      label: 'Batas waktu respons'
    },

    contact: {
      label: 'Metode kontak'
    }
  }
};
